import { Plus, X } from 'lucide-react';

interface Props {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
}

// Editor de lista de strings cortos (amenidades, tags). Estructurado para
// API/LLM — no un blob de richtext. Añadir/quitar/editar por fila.
export function TextListField({ value, onChange, placeholder }: Props) {
  const list = Array.isArray(value) ? value : [];

  const update = (i: number, v: string) => onChange(list.map((x, idx) => (idx === i ? v : x)));
  const remove = (i: number) => onChange(list.filter((_, idx) => idx !== i));
  const add = () => onChange([...list, '']);

  return (
    <div className="space-y-2">
      {list.map((item, i) => (
        <div key={i} className="flex items-center gap-2">
          <input
            type="text"
            value={item}
            onChange={(e) => update(i, e.target.value)}
            placeholder={placeholder}
            className="flex-1 bg-ui-bg border border-ui-border rounded-md px-3 py-1.5 text-sm text-ui-text focus:outline-none focus:border-ui-accent focus:ring-1 focus:ring-ui-accent/30 placeholder:text-ui-text-subtle transition-colors"
          />
          <button
            type="button"
            onClick={() => remove(i)}
            title="Quitar"
            className="p-1.5 text-ui-text-muted hover:text-ui-danger rounded transition-colors"
          >
            <X size={15} />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-ui-text-muted hover:text-ui-text border border-dashed border-ui-border hover:border-ui-border-strong rounded-md transition-colors"
      >
        <Plus size={13} /> Añadir elemento
      </button>
    </div>
  );
}
